
import './App.css';
import './index.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Homepage from './Pages/NewHomepage';
import Aboutus from './Pages/Newabout';
import Newcontact from './Pages/Newcontact'
import Pricing from './Pages/Pricing';
import Features from './Components/Features';
import Careers from './Pages/Careers';
import PartnerwithUs from './Pages/PartnerwithUs';
import InvestorRelations from './Pages/InvestorRelations';
import PrivacyPolicy from './Pages/PrivacyPolicy.jsx';
import TermsConditions from './Pages/TermsConditions.jsx';
import Security from './Pages/Security.jsx';
import Certificate from './Pages/Certificate.jsx';





function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/features" element={<Features />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/Contactus" element={<Newcontact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/partnerwithus" element={<PartnerwithUs />} />
          <Route path="/investor-relations" element={<InvestorRelations />} />
          <Route path="/privacy-Policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/security" element={<Security />} />
          <Route path="/certificate" element={<Certificate />} />



        </Routes>
      </Router>

    </>
  );
}

export default App;
